import { render, staticRenderFns } from "./SidebarNewClass.vue?vue&type=template&id=11668998"
import script from "./SidebarNewClass.vue?vue&type=script&lang=js"
export * from "./SidebarNewClass.vue?vue&type=script&lang=js"
import style0 from "./SidebarNewClass.vue?vue&type=style&index=0&id=11668998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports